const navItemsSkeletonInnerMarkup = `<div class="xpl-gh-nav-skeleton__items" aria-hidden="true">
    <xpl-skeleton shape="rectangle" size="h1"></xpl-skeleton>
    <xpl-skeleton shape="rectangle" size="h1"></xpl-skeleton>
    <xpl-skeleton shape="rectangle" size="h1"></xpl-skeleton>
    <xpl-skeleton shape="rectangle" size="h1"></xpl-skeleton>
    <xpl-skeleton shape="rectangle" size="h1"></xpl-skeleton>
    <xpl-skeleton shape="rectangle" size="h1"></xpl-skeleton>
    </div>`;

export function renderMainNavServicesLoadingSkeleton(
  navItemsContainer: HTMLUListElement,
): void {
  navItemsContainer.setAttribute('aria-busy', 'true');
  navItemsContainer.innerHTML = `<li class="xpl-gh-nav-skeleton" aria-hidden="true">${navItemsSkeletonInnerMarkup}</li>`;
}

export function clearMainNavServicesLoadingSkeleton(
  navItemsContainer: HTMLUListElement,
): void {
  navItemsContainer.removeAttribute('aria-busy');
}

/** Markup for the account header area while user / services are loading */
export const accountDetailsPreloaderSkeletonHtml = `<div class="xpl-gh-account-details-skeleton" aria-hidden="true">
    <xpl-skeleton shape="rectangle" size="h1"></xpl-skeleton>
    <xpl-skeleton shape="circle"></xpl-skeleton>
</div>`;
